module.exports = __webpack_public_path__ + "02_mustache_black.ae73508d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/02_mustache_black.png
// module id = efm8
// module chunks = 0